import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import yaml from 'js-yaml';

import '../css/TrustSection.css';

class TrustSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      latestPost: null,
      ur: {
        title: {
          "zh": "Universal Robots 認證解決方案供應商",
          "en": "Universal Robots Certified Solution Provider",
          "ja": "Universal Robots 認定ソリューションプロバイダー"
        },
        desc: {
          "zh": "Nexuni 是 Universal Robots 認證的 Solution Provider 與 Distributor，具備豐富的協作機器人整合經驗，為企業提供專業的機器手臂解決方案。",
          "en": "Nexuni is a certified Solution Provider and Distributor for Universal Robots, with extensive cobot integration experience delivering professional robotic arm solutions.",
          "ja": "Nexuni は Universal Robots の認定ソリューションプロバイダーおよびディストリビューターとして、豊富な協働ロボット統合経験を持ち、専門的なロボットアームソリューションを提供しています。"
        },
        logo: "/logo/logowall_ur.png"
      },
      nvidia: {
        title: {
          "zh": "NVIDIA Inception 新創計畫成員",
          "en": "NVIDIA Inception Program Member",
          "ja": "NVIDIA Inception プログラムメンバー"
        },
        desc: {
          "zh": "深度整合 NVIDIA 軟硬體平台，開發最先進的 AI 機器人技術，運用 NVIDIA Jetson、Isaac 與 Omniverse 打造智慧自動化。",
          "en": "Deeply integrating NVIDIA's hardware and software platforms to develop cutting-edge AI robotics, leveraging Jetson, Isaac, and Omniverse for intelligent automation.",
          "ja": "NVIDIA のハードウェアおよびソフトウェアプラットフォームを深く統合し、Jetson、Isaac、Omniverse を活用した最先端の AI ロボティクスを開発しています。"
        },
        logo: "/image/inception.png"
      },
      newsTitle: {
        "zh": "最新消息",
        "en": "Latest News",
        "ja": "最新ニュース"
      },
      newsReadMore: {
        "zh": "觀看影片",
        "en": "Watch Video",
        "ja": "動画を見る"
      }
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/yaml/blog_posts.yaml')
      .then(res => res.text())
      .then(text => {
        const parsed = yaml.load(text);
        if (parsed && parsed.posts && parsed.posts.length > 0) {
          // Show the robot dog news specifically
          const dogPost = parsed.posts.find(p => p.id === 'collie_sg_launch');
          this.setState({ latestPost: dogPost || parsed.posts[0] });
        }
      })
      .catch(() => {});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {
    const lang = this.state.lang;
    const post = this.state.latestPost;

    return (
      <div className="trust-section">
        <div className="trust-section-inner">
          <div className="trust-cards">
            {/* Latest News Card */}
            <Fade duration={800} delay={300}>
              <div className="trust-card trust-card-news" onClick={() => window.open('https://www.youtube.com/watch?v=gPjM8f-4x7w', '_blank')}>
                <div className="trust-card-news-badge">{this.state.newsTitle[lang]}</div>
                {post ? (
                  <>
                    <div className="trust-card-news-img-wrap">
                      <img src={post.image} alt={post.title ? post.title[lang] : ''} className="trust-card-news-img" />
                    </div>
                    <h3 className="trust-card-title">{post.title ? post.title[lang] : ''}</h3>
                    <p className="trust-card-news-date">{post.date}</p>
                  </>
                ) : (
                  <p className="trust-card-desc">...</p>
                )}
                <span className="trust-card-news-link">{this.state.newsReadMore[lang]} →</span>
              </div>
            </Fade>

            {/* NVIDIA Card */}
            <Fade duration={800} delay={450}>
              <div className="trust-card trust-card-static">
                <div className="trust-card-logo-wrap">
                  <img src={this.state.nvidia.logo} alt="NVIDIA Inception" className="trust-card-logo" />
                </div>
                <h3 className="trust-card-title">{this.state.nvidia.title[lang]}</h3>
                <p className="trust-card-desc">{this.state.nvidia.desc[lang]}</p>
              </div>
            </Fade>

            {/* UR Card */}
            <Fade duration={800} delay={600}>
              <div className="trust-card trust-card-static">
                <div className="trust-card-logo-wrap">
                  <img src={this.state.ur.logo} alt="Universal Robots" className="trust-card-logo" style={{ background: '#fff', borderRadius: '6px', padding: '8px 14px' }} />
                </div>
                <h3 className="trust-card-title">{this.state.ur.title[lang]}</h3>
                <p className="trust-card-desc">{this.state.ur.desc[lang]}</p>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    );
  }
}

export default TrustSection;
